import { DatePicker } from "antd";
import { RangePickerProps } from "antd/es/date-picker";
import dayjs from "dayjs";

import { ReactComponent as CalendarIcon } from "images/calendarIcon.svg";

import styles from "./dateInput.module.css";

const { RangePicker } = DatePicker;

export const DefaultRangeDateInput: React.FC<RangePickerProps> = (props) => (
  <RangePicker
    placeholder={["Дата от", "до"]}
    maxDate={dayjs()}
    className={styles.input}
    variant="outlined"
    format="DD.MM.YYYY"
    {...props}
    suffixIcon={props.suffixIcon ?? <CalendarIcon />}
  />
);
